import React from 'react';
import styled, { css } from 'styled-components';
import { colors } from '~/constants/colors';

interface FunPlaceholderProps {
  text: string;
  shrink: boolean;
  error: boolean;
  className?: string;
}

const PlaceholderContainer = styled.div.withConfig({ componentId: 'sc-12yec6l-0' })`
  position: relative;
`;

const Placeholder = styled.div.withConfig({ componentId: 'sc-12yec6l-1' })<{ error: boolean; shrink: boolean }>`
  font-size: 18px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;

  transition-duration: 0.2s;
  position: absolute;
  left: 20px;
  ${({ error, shrink }) => css`
    font-size: ${shrink ? '12px' : '18px'};
    top: ${shrink ? '8px' : '19px'};
    color: ${
      // eslint-disable-next-line no-nested-ternary
      error ? '#ff9494' : shrink ? `${colors.greyWorm}` : `${colors.lanaDelGrey}`
    };
  `};
`;

function FunPlaceholder({ text, shrink, error, className }: FunPlaceholderProps) {
  return (
    <PlaceholderContainer>
      <Placeholder className={className} error={error} shrink={shrink}>
        {text}
      </Placeholder>
    </PlaceholderContainer>
  );
}

export default FunPlaceholder;
